export const REDUCER_NAME = 'SEND_NEW_EMAIL';


